import commitMutation from 'relay-commit-mutation-promise';
import { graphql, type Environment } from 'react-relay';
import { type SelectorStoreUpdater } from 'relay-runtime';
import {
    type removePhotoLikeMutation as MutationType,
    type RemovePhotoLikeMutationInput,
} from './__generated__/removePhotoLikeMutation.graphql.ts';

const mutation = graphql`
    mutation removePhotoLikeMutation($input: RemovePhotoLikeMutationInput!) {
        removePhotoLikeMutation(input: $input) {
            success
        }
    }
`;

type UpdaterFnType = SelectorStoreUpdater<MutationType['response']>;

type RemovePhotoLikeInput = {
    environment: Environment;
    input: RemovePhotoLikeMutationInput;
    updater?: UpdaterFnType;
    optimisticUpdater?: UpdaterFnType;
};

export const removePhotoLikeMutation = ({
    environment,
    input,
    updater,
    optimisticUpdater,
}: RemovePhotoLikeInput): Promise<MutationType['response']> => {
    return commitMutation<MutationType>(environment, {
        mutation,
        variables: { input },
        updater,
        optimisticUpdater,
    });
};
